import { useIntl } from "react-intl";
const EmailAndWidgetSupport = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.EmailAndWidgetSupport.header",
            defaultMessage: "Email and embeddable widget support"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.EmailAndWidgetSupport.body",
            defaultMessage:
                "Let employees or customers submit requests or incidents straight to your queue via email and customize your notifications. Add a widget to your web page so that requestors can get help from whatever page they’re on."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default EmailAndWidgetSupport;
